import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import type { ClassValue } from 'clsx';
import { IconComponent, type IconSource } from '../../../@core/components/ui/icon/icon.component';
import { type ZardBadgeVariants } from '../../../@core/components/ui/badge/badge.variants';
import { type IconSize } from '../../../@core/components/ui/icon/icon.variants';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';
import { BadgeComponent } from 'src/app/@core/components/ui/badge/badge.component';

@Component({
  selector: 'app-icon-badge',
  standalone: true,
  imports: [IconComponent, BadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <app-icon 
      [type]="iconType()" 
      [source]="iconSource()" 
      [size]="iconSize()"
      [class]="iconClass()" 
    />
    <!-- @if (badgeValue() !== undefined && badgeValue() !== null && badgeValue() !== '') { -->
      <app-badge 
        [value]="badgeValue()" 
        [size]="badgeSize()"
        [variant]="badgeVariant()"
        [dot]="badgeDot()"
        [class]="badgeClasses()"
      />
    <!-- } -->
  `,
  host: {
    '[class]': '"relative inline-flex items-center justify-center " + class()',
  },
})
export class IconBadgeComponent {
  // Icon inputs
  readonly iconType = input.required<string>();
  readonly iconSource = input<IconSource>('svg');
  readonly iconSize = input<IconSize>('xl');
  readonly iconClass = input<ClassValue>('');

  // Badge inputs
  readonly badgeValue = input<string | number>();
  readonly badgeSize = input<ZardBadgeVariants['zSize']>('sm');
  readonly badgeVariant = input<ZardBadgeVariants['zVariant']>('default');
  readonly badgeDot = input<boolean>(false);
  readonly badgePosition = input<'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'>('top-right');

  // Component class
  readonly class = input<ClassValue>('');

  protected readonly badgeClasses = computed(() => {
    const position = this.badgePosition();
    const baseClasses = 'absolute';

    const positionClasses = {
      'top-right': 'top-0 right-0',
      'top-left': '-top-1 -left-2',
      'bottom-right': '-bottom-1 -right-2',
      'bottom-left': '-bottom-1 -left-2',
    };

    return mergeClasses(baseClasses, positionClasses[position]);
  });
}

